export const metrics = [
  { title: "Additional Total Sales", value: "$1,440,895" },
  { title: "Additional Contribution Profit", value: "$327,947" },
  { title: "Additional Contribution Margin", value: "0.98%" },
];
